import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import LoginForm from '../LoginForm';
import StudentPortalForm from '../StudentPortalForm';

const Login = () => {
  const location = useLocation();
  const [panel, setPanel] = useState('student');

  useEffect(() => {
    const nextPanel = new URLSearchParams(location.search).get('panel') === 'admin'
      ? 'admin'
      : 'student';

    setPanel(nextPanel);
  }, [location.search]);

  return (
    <div className="psi-auth-stack">
      <div className={`psi-login-panel ${panel === 'student' ? 'psi-login-panel--student' : ''}`}>
        {panel === 'student' ? (
          <StudentPortalForm onSwitchToAdmin={() => setPanel('admin')} />
        ) : (
          <>
            <div className="psi-login-panel__top">
              <div className="psi-login-panel__mark">
                <img src="https://psixologiya.suvoriy.com/kutubxona/images/favicon.png" alt="PSI logo" />
              </div>
              <div className="psi-login-panel__headline">
                <h2 className="psi-login-title">Tizimga kirish</h2>
              </div>
            </div>

            <div className="psi-login-panel__divider" />

            <LoginForm hasLabel />

            <div className="psi-auth-switch">
              <button
                type="button"
                className="psi-auth-switch__link"
                onClick={() => setPanel('student')}
              >
                Talaba kirishiga o`tish
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Login;
